import { createSlice, CaseReducer, PayloadAction } from '@reduxjs/toolkit';

import { get } from 'api/requests';
import { setValueToLocalStorage } from 'utils';

import { UNDISTRIBUTES_TIME } from 'consts';

import { AppThunk } from 'store/types';
import { ApartamentsStore, Undestributed } from 'features/GlobalNotification/types';

const initialState: ApartamentsStore = {
  undistributed: [],
};

const undistributed: CaseReducer<ApartamentsStore, PayloadAction<Undestributed[]>> = (
  state,
  action,
) => {
  state.undistributed = action.payload;
};

export const globalNotificationSlice = createSlice({
  name: 'globalNotification',
  initialState,
  reducers: {
    undistributed,
  },
});

const { undistributed: setUndistributed } = globalNotificationSlice.actions;

export const getUndistributed = (): AppThunk => dispatch => {
  get<Undestributed[]>('/api/settlement/plan/list_undistributed/').then(({ data }) => {
    dispatch(setUndistributed(data));
    setValueToLocalStorage(UNDISTRIBUTES_TIME, new Date().getTime());
  });
};
